import React from 'react'
import { FiDownload } from 'react-icons/fi'
import Container from './styles'

const LinkList = ({ links, title = 'Links' }) => {
  return (
    <Container>
      <div className="center">
        <h2>{title}</h2>
        <ul>
          {links.map(item => (
            <li key={item.tituloLink}>
              <div className="linkHeader">
                <h3>{item.tituloLink}</h3>
                <a
                  href={item.url}
                  title={item.tituloLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download
                  <FiDownload />
                </a>
              </div>
              {item.descricao !== '' ? (
                <div className="linkDescription">
                  <p>{item.descricao}</p>
                </div>
              ) : (
                ''
              )}
            </li>
          ))}
        </ul>
      </div>
    </Container>
  )
}

export default LinkList
